import React from "react";
import classes from "./Header.module.css";
import { useSpring, animated } from "react-spring";

function Header() {
  const fade = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { delay: 100, duration: 1000 },
  });

  const styles = useSpring({
    loop: true,
    from: {
      scale: 1.3,
    },
    to: {
      scale: 0.8,
    },
    config: { delay: 100, duration: 2000 },
  });

  return (
    <header className={classes.Header}>
      <animated.div className={classes.HeaderContent} style={fade}>
        <h1 className={classes.PrimaryHeading}>
          All africa <span>Hub</span>
        </h1>
        <p className={classes.HeaderText}>
          oda under which African resolve their problem by themselves.
        </p>
        <animated.a href="/" className={classes.HeaderBtn} style={styles}>
          Get started
        </animated.a>
      </animated.div>
      <div className={classes.HeaderImgCont}>
        <div className={classes.HeaderImg}></div>
      </div>
    </header>
  );
}

export default Header;
